import React from 'react';
import { Typography } from '../../../design-system';
import { colors } from '../../../design-system/colors';
import { HERO_TITLE } from '../constants/landingText';

interface HeroSectionTitleProps {
  fontSize?: { xs: string; md: string };
  maxWidth?: string;
}

const HeroSectionTitle: React.FC<HeroSectionTitleProps> = ({
  fontSize = { xs: '2.5rem', md: '4.5rem' },
  maxWidth = '50rem',
}) => {
  return (
    <Typography
      variant="headingXLarge"
      component="h1"
      sx={{
        fontSize,
        fontWeight: 700,
        lineHeight: { xs: '1.2', md: '1.1' },
        color: colors.neutral.white,
        mb: { xs: 4, md: 3 },
        textAlign: 'center',
        maxWidth,
        margin: '0 auto',
        fontFamily: 'Outfit, sans-serif',
      }}
    >
      {HERO_TITLE}
    </Typography>
  );
};

export default HeroSectionTitle;
